import { autocomplete as bool } from './bool'
import { autocomplete as date } from './date'
import { autocomplete as number } from './number'

export default function predict(string = '') {
	const words = string.trim().toLowerCase().split(' ')
	const first = words[0]

	switch (first) {
		case 'how':
			if (words[1] === 'many') {
				return number()
			}
			return []
		case 'should':
			return bool()
		case 'when':
			return date()
		default:
			return []
	}
}



// WEBPACK FOOTER //
// ./src/services/prediction/question.js